import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import {
  DownloadTypes,
  getURLToDownloadFile,
} from '@/services/get-url-to-download-file'

export function useDownloadFilesFromDemand(culture: string, demandId: string) {
  return useMutation(
    async ({
      type,
      waitInMs = 0,
    }: {
      type: DownloadTypes
      waitInMs?: number
    }) => {
      const url = await getURLToDownloadFile(culture, demandId, type)

      const link = document.createElement('a')
      link.href = url
      link.download = ''

      await new Promise((resolve) => setTimeout(resolve, waitInMs))
      link.click()
    },
    {
      onError(e: any) {
        toast.error(
          'Ocorreu um erro ao realizar o download dos arquivos: ' + e.message,
        )
      },
    },
  )
}
